import styled, { keyframes } from "styled-components";
import { tada, fadeIn } from "react-animations";

const tadaAnimation = keyframes`${tada}`;
const fadeAnimation = keyframes`${fadeIn}`;

export const Card = styled.div`
  @font-face {
    font-family: "My Writing";
    src: url("fonts/mywriting.ttf") format("woff");
  }

  animation: 1s ${fadeAnimation};
  background-color: ${(props) => `${props.borderColor}`};
  border-radius: 8px;
  border: solid 1px rgb(0, 0, 0);
  display: flex;
  flex-direction: column;
  font-family: "My Writing";

  width: 17rem;
  height: 19rem;

  :hover {
    animation: 1s ${tadaAnimation};
    width: 18rem;

    .hide {
      display: block;
      height: 5rem;
      background-color: ${(props) => `${props.borderColor}`};
      border-radius: 0 0 8px 8px;
    }

    .no-hide {
      display: none;
    }
  }

  .no-hide {
    /* width: 100%;
    color: #fff;
    text-align: center;
    background-color: ${(props) => `${props.borderColor}`}; */

    width: 100%;
    color: #fff;
    text-align: center;
    display: flex;
    background-color: ${(props) => `${props.borderColor}`};
    border-radius: 0 0 8px 8px;
    justify-content: center;
  }

  .no-hide p {
    font-size: 1.3rem;
  }

  img {
    width: 45%;
    width: 100%;
    object-fit: cover;
    margin: 0px;
  }

  h3 {
    font-family: "My Writing";
    text-align: center;
    color: #fff;
    font-size: 1.5rem;
    -webkit-text-stroke: 1px black;
  }

  div {
    display: flex;
    flex-direction: column;
    padding: 0.5rem;
    justify-content: space-between;
    gap: 0.5rem;
  }

  p {
    font-size: 16px;
    font-family: "My Writing";
  }

  .hide {
    display: none;
  }
`;
